const Hero = ({ className, children }) => (
    <section className={'hero ' + className}>
        <div className="hero-body">
            {children}
        </div>
    </section>
);

export { Hero };
